const services = [
  {
    icon: 'ri-user-search-line',
    title: 'Tenant Screening',
    description:
      'Rigorous, multi-layered vetting of prospective tenants — including background checks, financial verification, and reference validation — to ensure only the most qualified individuals occupy your property.',
    href: '#tenant-screening',
  },
  {
    icon: 'ri-file-text-line',
    title: 'Lease Management',
    description:
      'Comprehensive lease drafting, renewal coordination, and compliance oversight. We handle every aspect of the tenancy lifecycle with meticulous attention to legal detail and client protection.',
    href: '#lease-management',
  },
  {
    icon: 'ri-tools-line',
    title: 'Maintenance Coordination',
    description:
      'Seamless coordination of all property maintenance — from routine upkeep to urgent repairs — through our trusted network of vetted professionals, ensuring your asset is always in pristine condition.',
    href: '#maintenance-coordination',
  },
];

export default function Services() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="services" className="w-full bg-white py-28 px-6 md:px-16">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center border border-[#2C2C2C] rounded-full px-5 py-2 mb-6">
            <span className="text-xs uppercase tracking-[0.2em] text-[#2C2C2C] font-medium">
              — What We Offer
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-semibold text-[#1A1A1A] mb-4">
            Comprehensive Management
          </h2>
          <p className="text-[#5A5A5A] text-base md:text-lg font-light max-w-xl mx-auto">
            Tailored solutions for long-term, short-term, and vacation properties
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service) => (
            <div
              key={service.title}
              className="group border-2 border-[#E8E6E3] rounded-lg p-10 flex flex-col gap-6 hover:bg-[#2C2C2C] transition-all duration-400 cursor-pointer"
              onClick={() => handleScroll(service.href)}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#F5F4F2] group-hover:bg-white/15 transition-colors duration-400">
                <i className={`${service.icon} text-xl text-[#8B7355] group-hover:text-white transition-colors duration-400`}></i>
              </div>
              <h3 className="text-xl font-semibold text-[#1A1A1A] group-hover:text-white transition-colors duration-400">
                {service.title}
              </h3>
              <p className="text-sm text-[#5A5A5A] group-hover:text-white/75 leading-relaxed font-light transition-colors duration-400">
                {service.description}
              </p>
              <div className="mt-auto flex items-center gap-2 text-[#8B7355] group-hover:text-white/80 transition-colors duration-400">
                <span className="text-xs uppercase tracking-[0.15em] font-medium">Learn More</span>
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
